import Typography from '~/shared/components/Typography';
import { type OptLogSnapshotDisplayRow } from '~/shared/utils/optLogActionSnapshot';

import OptLogSnapshotBlankMetricLine from './OptLogSnapshotBlankMetricLine';

export interface ReportsActionSnapshotCellProps {
  rows: OptLogSnapshotDisplayRow[];
}

export default function ReportsActionSnapshotCell({ rows }: ReportsActionSnapshotCellProps) {
  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="flex w-max min-w-0 flex-col gap-[6px]">
      {rows.map((row) => (
        <div key={row.kind} className="flex min-h-[20px] flex-col gap-[2px]">
          {row.isPlaceholder ? (
            <OptLogSnapshotBlankMetricLine />
          ) : (
            <>
              <div
                className="flex items-center gap-[6px] whitespace-nowrap font-family-inter"
                aria-label={
                  row.kind === 'tier' && row.primarySuffix
                    ? `${row.primaryValue} ${row.primarySuffix}`
                    : undefined
                }
              >
                <Typography fontWeight={500} variant="p3" color="text-primary-900">
                  {row.primaryValue}
                </Typography>
                {row.primarySuffix ? (
                  <Typography
                    fontWeight={500}
                    variant="p3"
                    color={row.kind === 'tier' ? 'text-primary-900' : 'text-gray'}
                  >
                    {row.primarySuffix}
                  </Typography>
                ) : null}
              </div>
              {row.secondaryText ? (
                <Typography variant="caption" className="text-gray-500">
                  {row.secondaryText}
                </Typography>
              ) : null}
            </>
          )}
        </div>
      ))}
    </div>
  );
}
